import { useCallback, useMemo, useState } from 'react';
import { RowSelectionState } from '@tanstack/react-table';

export const useSelectedRows = <D extends object>() => {
  const [selectedRowsPerPage, setSelectedRows] = useState<Record<string, D[]>>({});
  const flatSelectedRows = useMemo(() => Object.values(selectedRowsPerPage).flat(), [selectedRowsPerPage]);
  const [reactTableRowSelection, setReactTableRowSelection] = useState<RowSelectionState>({});

  const clearAllSelectedRows = useCallback(() => {
    setSelectedRows({});
    setReactTableRowSelection({});
  }, []);

  const setSelectedRowsHandler = useCallback(
    (selectedOriginal: D[], pageIndex: string) =>
      setSelectedRows((prevState) => ({ ...prevState, [pageIndex]: selectedOriginal ?? [] })),
    []
  );
  return {
    selectedRows: flatSelectedRows,
    setSelectedRows: setSelectedRowsHandler,
    clearAllSelectedRows,
    reactTableRowSelection: { rowSelection: reactTableRowSelection, setRowSelection: setReactTableRowSelection }
  };
};
